import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllStagesNames, updateStatus } from "../services/stages.service";

const initialState = {
  stagesNamesData: null,
  isStagesNamesLoading: false,
  stageNameError: null,

  isStatusUpdating: false,
  statusUpdateError: null,
  statusUpdateData: null,
};

export const fetchStagesNames = createAsyncThunk(
  "stages/stagesNames",
  async (_, { rejectWithValue }) => {
    try {
      const apiResponse = await getAllStagesNames();
      const data = await apiResponse.data.data;
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const updateNextStatus = createAsyncThunk(
  "stages/updateNextStatus",
  async ({ domain, ...request }, { rejectWithValue }) => {
    try {
      const apiResponse = await updateStatus(request, domain);
      const data = await apiResponse.data.data;
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const stagesSlice = createSlice({
  name: "stages",
  initialState,
  reducers: {
    clearStatusUpdate(state) {
      state.statusUpdateData = null;
      state.statusUpdateError = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchStagesNames.pending, (state) => {
        state.isStagesNamesLoading = true;
        state.stageNameError = null;
      })
      .addCase(fetchStagesNames.fulfilled, (state, action) => {
        state.isStagesNamesLoading = false;
        state.stagesNamesData = action.payload;
      })
      .addCase(fetchStagesNames.rejected, (state, action) => {
        state.isStagesNamesLoading = false;
        state.stageNameError = action.payload;
      })
      .addCase(updateNextStatus.pending, (state) => {
        state.isStatusUpdating = true;
        state.statusUpdateError = null;
      })
      .addCase(updateNextStatus.fulfilled, (state, action) => {
        state.isStatusUpdating = false;
        state.statusUpdateData = action.payload;
      })
      .addCase(updateNextStatus.rejected, (state, action) => {
        state.isStatusUpdating = false;
        state.statusUpdateError = action.payload;
      });
  },
});

export const { clearStatusUpdate } = stagesSlice.actions;

export default stagesSlice.reducer;
